import { useLayoutEffect, useRef } from 'react'
import { debounce, throttle } from 'throttle-debounce'

import type { UseTextFitOptions } from './types'
import { resizeText } from './utils'

const config = { attributes: true, childList: true, characterData: true }

function useTextFit({ maxSize }: UseTextFitOptions) {
  const ref = useRef<HTMLDivElement>(null)
  const debounceResize = debounce(250, resizeText({ maxSize }))
  const throttledResize = throttle(25, resizeText({ maxSize }))

  useLayoutEffect(() => {
    if (ref.current && ref.current?.parentNode) {
      const parent = ref.current.parentNode as HTMLDivElement
      const observer = new MutationObserver(function (mutationList) {
        mutationList.forEach(() => {
          if (parent && ref.current) {
            throttledResize({ element: ref.current, parent })
          }
        })
      })

      observer.observe(parent, config)

      // Debounce size at initial load (in case of async, flags etc.)
      debounceResize({ element: ref.current, parent })

      return () => {
        observer.disconnect()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxSize, ref])

  return ref
}

export default useTextFit
